

import { chinaData } from './chinaData';
import { chinaAdditionalCities2 } from './chinaExpansion2';
import { chinaSouthernCities } from './chinaSouthernCities';
import { indiaAdditionalCities3 } from './indiaExpansion3';
import { japanAdditionalCities } from './japanExpansion';
import { southKoreaData } from './southKoreaData';
import { southKoreaExpansion2 } from './southKoreaExpansion2';
import { eastAsiaData } from './eastAsiaData';
import { southAsiaCountries } from './southAsiaData';
import { southeastAsiaData } from './southeastAsiaData';
import { southeastAsiaExpansion } from './southeastAsiaExpansion';
import { thailandExpanded } from './thailandExpansion';
import { vietnamAdditionalCities } from './vietnamExpansion';
import { indonesiaExpanded } from './indonesiaExpansion';
import { indonesiaExpansion3 } from './indonesiaExpansion3';
import { southeastAsiaExpansion2 } from './southeastAsiaExpansion2';
import { philippinesExpansion3 } from './philippinesExpansion3';
import { southAsiaExpansion } from './southAsiaExpansion';
import { asiaExpansion11 } from './asiaExpansion11';
import { asiaExpansion12 } from './asiaExpansion12';
import { WorldCountry } from '../types';

export const asiaCountries: WorldCountry[] = [
  // China con todas sus expansiones
  {
    ...chinaData,
    topCities: [
      ...chinaData.topCities,
      ...chinaAdditionalCities2,
      ...chinaSouthernCities
    ]
  },
  // India con todas sus expansiones (ya incluidas en southAsiaCountries)
  ...southAsiaCountries,
  // Japón expandido
  {
    code: 'JP',
    name: 'Japan',
    slug: 'japan',
    population: 125416877,
    topCities: [
      { name: 'Tokyo', slug: 'tokyo', population: 37400068 },
      { name: 'Yokohama', slug: 'yokohama', population: 3726167 },
      { name: 'Osaka', slug: 'osaka', population: 2725006 },
      { name: 'Nagoya', slug: 'nagoya', population: 2296014 },
      { name: 'Sapporo', slug: 'sapporo', population: 1952356 },
      { name: 'Fukuoka', slug: 'fukuoka', population: 1538681 },
      { name: 'Kobe', slug: 'kobe', population: 1537272 },
      { name: 'Kawasaki', slug: 'kawasaki', population: 1475213 },
      { name: 'Kyoto', slug: 'kyoto', population: 1474570 },
      { name: 'Saitama', slug: 'saitama', population: 1324854 },
      ...japanAdditionalCities
    ]
  },
  // Corea del Sur expandida (Fase 7)
  ...southKoreaExpansion2,
  // Indonesia expandida (Fase 7)
  ...indonesiaExpansion3,
  thailandExpanded,
  // Vietnam expandido
  {
    code: 'VN',
    name: 'Vietnam',
    slug: 'vietnam',
    population: 97340000,
    topCities: [
      { name: 'Ho Chi Minh City', slug: 'ho-chi-minh-city', population: 8993082 },
      { name: 'Hanoi', slug: 'hanoi', population: 4974000 },
      { name: 'Can Tho', slug: 'can-tho', population: 1235171 },
      { name: 'Da Nang', slug: 'da-nang', population: 1007700 },
      { name: 'Bien Hoa', slug: 'bien-hoa', population: 821000 },
      { name: 'Hue', slug: 'hue', population: 455230 },
      { name: 'Nha Trang', slug: 'nha-trang', population: 404358 },
      { name: 'Buon Ma Thuot', slug: 'buon-ma-thuot', population: 340000 },
      { name: 'Vung Tau', slug: 'vung-tau', population: 327000 },
      { name: 'Quy Nhon', slug: 'quy-nhon', population: 284535 },
      ...vietnamAdditionalCities
    ]
  },
  ...eastAsiaData,
  ...southeastAsiaExpansion,
  ...southeastAsiaData,
  // Filipinas expandida (Fase 7)
  ...philippinesExpansion3,
  ...southAsiaExpansion, // Nueva expansión con Pakistán y Bangladesh
  ...asiaExpansion11, // Incluye Indonesia, Filipinas y Vietnam expandidos - Fase 11
  ...asiaExpansion12  // Incluye Singapur 100+ ciudades, Laos y Camboya - Fase 12
];

